import { Inject, Component, Input } from '@angular/core';
import { TranslationService } from '../../services/languages/translation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-sub-features',
    templateUrl: './sub-features.component.html',
    styleUrls: ['./sub-features.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgIf, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatDialogClose, TranslatePipe]
})
export class SubFeaturesComponent {

  /**
  * @var title to store the feature Group Name
  **/
  public title: string;
  /**
   * @property displayedColumns used to store the columns for the sub features table.
   */
  public displayedColumns: string[];
    /**
   * @property dataSource used to store the data for the sub features table.
   */
  public dataSource: Array<any>;
  constructor(
    private readonly snackBarRef: MatDialogRef<SubFeaturesComponent>,
    public translate: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.displayedColumns = ['subFeature', 'compatibilty'];
    this.dataSource = data.subFeature;
    this.title = data.featureGroupName;

  }
  /**
  * @method close close the confirmation dialog
  **/
  close(): void {
    this.snackBarRef.close();
    this.dataSource = [];
  }
}
